import axiosClient from './setup/axiosClient';

export interface IBranchConfigQueryParams {
  search?: string;
  plantId?: string;
  active?: boolean;
  page?: number;
  limit?: number;
}

export interface ICreateBranchConfigData {
  plantId: string;
  plantName?: string;
  terminalId?: string;
  merchantId?: string;
  prctr?: string;
  description?: string;
  active?: boolean;
}

export interface IUpdateBranchConfigData {
  plantName?: string;
  terminalId?: string;
  merchantId?: string;
  prctr?: string;
  description?: string;
  active?: boolean;
}

export const BranchConfigApi = {
  getBranchConfigs: async (params?: IBranchConfigQueryParams) => {
    return await axiosClient.get('/plant-config', { params });
  },

  getBranchConfigById: async (id: number) => {
    return await axiosClient.get(`/plant-config/${id}`);
  },

  createBranchConfig: async (data: ICreateBranchConfigData) => {
    return await axiosClient.post('/plant-config', data);
  },

  updateBranchConfig: async (id: number, data: IUpdateBranchConfigData) => {
    return await axiosClient.put(`/plant-config/${id}`, data);
  },
};
